document.addEventListener('DOMContentLoaded', () => {
  const page = document.querySelector('.template-page-gtr-history #MainContent');
  if (!page) return;

  const historySections = [...page.querySelectorAll('.ormsby-section-container')];
  const firstHeader = historySections[0]?.querySelector('header');
  const navSection = page.querySelector('.shopify-section.page-nav-menu');

  if (firstHeader) {
    const hero = document.createElement('header');
    hero.className = 'gtr-history-hero';
    hero.innerHTML = firstHeader.innerHTML;
    historySections[0].closest('.shopify-section')?.before(hero);
    firstHeader.hidden = true;
  }

  if (navSection && historySections[0]) {
    historySections[0].closest('.shopify-section')?.before(navSection);
    navSection.querySelector('nav')?.setAttribute('aria-label', 'GTR history runs');
  }

  historySections.forEach((container) => {
    const decorativeHeader = container.querySelector('header:not([hidden])');
    const decorativeTitle = decorativeHeader?.querySelector('.main-title')?.textContent.trim() || '';
    if (!decorativeTitle || /^[﹋\s]+$/.test(decorativeTitle)) {
      if (decorativeHeader) decorativeHeader.hidden = true;
    }

    const runHeading = container.querySelector('.section-title');
    if (runHeading) {
      const runName = runHeading.textContent.replace(/^-+|-+$/g, '').trim();
      const runId = runName.toLowerCase().replace(/[^a-z0-9]+/g, '');
      const runSection = runHeading.closest('.bg-card');
      if (runSection && runId) {
        runSection.id = runId;
        runSection.classList.add('gtr-history-run');
        runHeading.textContent = runName;
      }
    }
  });

  page.querySelectorAll('.enhanced-richtext p').forEach((paragraph) => {
    const lines = [];
    let currentLine = [];

    paragraph.childNodes.forEach((node) => {
      if (node.nodeName === 'BR') {
        if (currentLine.length) lines.push(currentLine);
        currentLine = [];
      } else {
        currentLine.push(node.cloneNode(true));
      }
    });
    if (currentLine.length) lines.push(currentLine);

    const specificationLines = lines.filter((line) => line.some((node) => node.nodeName === 'STRONG'));
    const precedingList = paragraph.previousElementSibling?.matches('.gtr-history-specs')
      ? paragraph.previousElementSibling
      : null;
    if (specificationLines.length < 4 && !precedingList) return;

    const list = precedingList || document.createElement('dl');
    if (!precedingList) list.className = 'gtr-history-specs';

    let currentDetail = null;

    lines.forEach((line) => {
      const strong = line.find((node) => node.nodeName === 'STRONG');
      if (!strong) {
        if (!currentDetail) return;

        const continuation = line
          .map((node) => node.textContent)
          .join('')
          .trim();
        if (!continuation) return;

        if (currentDetail.textContent.trim()) {
          currentDetail.appendChild(document.createElement('br'));
        }
        line.forEach((node) => currentDetail.appendChild(node.cloneNode(true)));
        return;
      }

      const term = document.createElement('dt');
      term.textContent = strong.textContent.replace(/:\s*$/, '').trim();

      const detail = document.createElement('dd');
      let afterLabel = false;
      line.forEach((node) => {
        if (node === strong) {
          afterLabel = true;
          return;
        }
        if (afterLabel) detail.appendChild(node.cloneNode(true));
      });

      detail.innerHTML = detail.innerHTML.replace(/^[:\s\u00a0]+/, '').trim();
      list.append(term, detail);
      currentDetail = detail;
    });

    if (precedingList) {
      paragraph.remove();
    } else {
      paragraph.replaceWith(list);
    }
  });

  const navLinks = [...page.querySelectorAll('.page-nav-menu .nav-link[href^="#"]')];
  const observedRuns = navLinks
    .map((link) => document.querySelector(link.getAttribute('href').toLowerCase()))
    .filter(Boolean);

  if ('IntersectionObserver' in window && observedRuns.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        const active = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!active) return;

        navLinks.forEach((link) => {
          const isActive = link.getAttribute('href').toLowerCase() === `#${active.target.id}`;
          link.toggleAttribute('aria-current', isActive);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );

    observedRuns.forEach((run) => observer.observe(run));
  }

  const lightbox = document.createElement('dialog');
  lightbox.className = 'gtr-history-lightbox';
  lightbox.innerHTML = `
    <button class="gtr-history-lightbox__close" type="button" aria-label="Close image">Close</button>
    <div class="gtr-history-lightbox__media">
      <img src="" alt="">
      <p class="gtr-history-lightbox__caption"></p>
    </div>
  `;
  document.body.appendChild(lightbox);

  const lightboxImage = lightbox.querySelector('img');
  const lightboxCaption = lightbox.querySelector('.gtr-history-lightbox__caption');
  const closeButton = lightbox.querySelector('.gtr-history-lightbox__close');
  let opener = null;

  const closeLightbox = () => {
    lightbox.close();
    opener?.focus();
  };

  const openLightbox = (image) => {
    opener = image;
    const caption =
      image.closest('.image-grid-item')?.querySelector('p')?.textContent.trim() ||
      image.closest('.flex-item')?.querySelector('.block-title')?.textContent.trim() ||
      image.alt ||
      'GTR archive image';
    const source = image.currentSrc || image.src;

    lightboxImage.src = source.replace(/([?&])width=\d+/, '$1width=1800');
    lightboxImage.alt = image.alt || caption;
    lightboxCaption.textContent = caption;
    lightboxCaption.hidden = !caption;
    lightbox.showModal();
    closeButton.focus();
  };

  page.querySelectorAll('.side-image, .image-grid-item img').forEach((image) => {
    const caption =
      image.closest('.image-grid-item')?.querySelector('p')?.textContent.trim() ||
      image.closest('.flex-item')?.querySelector('.block-title')?.textContent.trim() ||
      'archive image';

    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', `View ${caption} larger`);
    image.addEventListener('click', () => openLightbox(image));
    image.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLightbox(image);
      }
    });
  });

  closeButton.addEventListener('click', closeLightbox);
  lightbox.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeLightbox();
  });
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
});
